(() => {
  window.nnReady = true;   // the page script has started (the watchdog in <head> stands down)
  // Neris ir Nemunas homepage scripts. Each part runs on its own (run), so a problem in one part never stops the
  // others or leaves the page hidden. The reveal on scroll goes first and shows everything if it cannot work.
  const run = (name, part) => {
    (window.nnParts = window.nnParts || {})['home:' + name] = () => { try { part(); } catch (err) { console.error(`[homepage] ${name}:`, err); } };
    try { part(); } catch (err) { console.error(`[homepage] ${name}:`, err); }
  };
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;



  run('product films', () => {
    // The two product films before the bestsellers: silent and looping; each loads when it comes near the screen,
    // plays while in view and pauses out of it, starting from the moment its cover shows (data-start). With reduced
    // motion the cover stays. Where the phone refuses to start it (iOS Low Power Mode), the sharp cover stays and the
    // play ring comes on it; pressing the ring plays the film (the rest of the picture still opens the collection).
    const films = [...document.querySelectorAll('video[data-src]')];
    if (!films.length || still || !('IntersectionObserver' in window)) return;
    const begin = (v) => {
      if (v.getAttribute('src')) return;
      v.src = v.dataset.src;
      const at = Number(v.dataset.start);
      if (at) v.addEventListener('loadedmetadata', () => { v.currentTime = at; }, { once: true });
    };
    const ring = (v) => {
      let b = v.parentElement.querySelector('.nn-play');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'nn-play';
        b.setAttribute('aria-label', 'Paleisti filmą');
        b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 5.8v12.4L18.6 12z"/></svg>';
        b.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          v.dataset.asked = '1';
          begin(v);
          const p = v.play();
          if (p) p.catch(() => {});
        });
        v.addEventListener('playing', () => b.classList.add('is-gone'));
        v.parentElement.appendChild(b);
      }
      b.classList.remove('is-gone');
    };
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) {
        begin(v);
        v.muted = true;
        const p = v.play();
        // refused (iOS Low Power Mode, a browser set to block): back to the sharp cover, nothing more downloaded, and the
        // ring on it (once pressed, the film keeps its place)
        if (p) p.catch((e) => {
          if (!e || e.name !== 'NotAllowedError') return;
          if (!v.dataset.asked) { v.removeAttribute('src'); v.load(); }
          ring(v);
        });
      } else if (v.getAttribute('src')) {
        v.pause();
      }
    }), { rootMargin: '200px 0px', threshold: 0.01 });
    films.forEach((v) => io.observe(v));
  });

  run('tabs', () => {
    // Women / men tabs of the bestsellers: only their own section's panels (collection and product grids elsewhere on a
    // page carry data-panel too).
    const tabs = [...document.querySelectorAll('[data-tab]')];
    if (!tabs.length) return;
    const box = tabs[0].closest('section') || document;
    const panels = [...box.querySelectorAll('[data-panel]')];
    const allLink = box.querySelector('[data-all-link]');
    const allText = box.querySelector('[data-all-text]');
    const select = (name, focus) => {
      tabs.forEach((t) => {
        const on = t.dataset.tab === name;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== name; });
      if (allLink && allText) {
        allLink.href = allLink.dataset[name];
        allText.textContent = allLink.dataset[`${name}Text`] || (name === 'neris' ? 'Visi laikrodžiai moterims' : 'Visi laikrodžiai vyrams');
      }
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t.dataset.tab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next.dataset.tab, true);
      });
    });
    select('neris');
  });


  run('film', () => {
    // The quality film: the 16:9 cut on computers and the 9:16 cut on phones, chosen by the screen (and swapped, keeping
    // the place, if that changes). It loads only when the section comes near, plays muted in a loop while it is on
    // screen and pauses when it is not (or when another tab is in front); for people who prefer less motion it waits on
    // its poster until they press play. Its sound, Clyde's voice over the film's own sound, is inside the film
    // (2026-10-18, the owner: "just make it one video"): "Įjungti garsą" turns the film's sound on, "Išjungti garsą"
    // off. The other button pauses and plays. What the voice is saying goes to data-chapter, which shows the same words
    // in the film ("end": no title). If the film cannot load, the poster stays and the buttons go.
    const film = document.querySelector('[data-film]');
    const video = film && film.querySelector('video');
    if (!video) return;
    const soundBtn = film.querySelector('[data-film-sound]');
    const playBtn = film.querySelector('[data-film-play]');
    const phone = matchMedia('(max-width:640px)');
    const parse = (s) => (s || '').trim().split(/\s+/).filter(Boolean).map((p) => {
      const [t, k] = p.split(':');
      return { t: Number(t), k };
    });
    const chapters = { wide: parse(film.dataset.chaptersWide), tall: parse(film.dataset.chaptersTall) };
    let kind = '';
    let inView = false;
    let held = still;                    // paused by the visitor (or waiting for play, for less motion)
    let raf = 0;

    const label = () => {
      film.classList.toggle('is-held', held);
      if (playBtn) playBtn.setAttribute('aria-label', held ? 'Paleisti filmą' : 'Sustabdyti filmą');
    };
    const setSound = (on) => {           // the button's words say what it does
      video.muted = !on;
      if (on) video.volume = 1;
      film.classList.toggle('has-sound', on);
      const said = film.querySelector('[data-film-sound-label]');
      if (said) said.textContent = on ? 'Išjungti garsą' : 'Įjungti garsą';
    };
    const update = () => {
      const want = kind && inView && !held && !document.hidden;
      if (want && video.paused) {
        const p = video.play();
        if (p && p.catch) p.catch((e) => {
          if (!e || e.name !== 'NotAllowedError') return;
          if (!video.muted) { setSound(false); update(); return; }   // sound refused (e.g. back on screen on a phone): on, muted
          held = true;                   // refused altogether (iOS Low Power Mode, a browser set to block): the play button
          film.classList.add('is-refused'); // and the play ring in the middle
          label();
        });
      } else if (!want && !video.paused) video.pause();
    };
    const load = () => {                  // the cut for this screen; keeps the place when it swaps
      const k = phone.matches ? 'tall' : 'wide';
      if (k === kind) return;
      const at = kind ? video.currentTime : 0;
      kind = k;
      film.dataset.kind = k;
      film.classList.remove('is-playing');
      video.src = film.dataset[k];
      if (at) video.addEventListener('loadedmetadata', () => { video.currentTime = at; }, { once: true });
      update();
    };
    const tick = () => {
      const t = video.currentTime;
      let cur = '';
      (chapters[kind] || []).forEach((c) => { if (t >= c.t) cur = c.k; });
      if (cur && film.dataset.chapter !== cur) film.dataset.chapter = cur;
      raf = requestAnimationFrame(tick);
    };
    video.addEventListener('playing', () => { film.classList.add('is-playing'); film.classList.remove('is-refused'); });
    video.addEventListener('play', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); });
    video.addEventListener('pause', () => cancelAnimationFrame(raf));
    video.addEventListener('error', () => film.classList.add('is-broken'));
    document.addEventListener('visibilitychange', update);
    if (soundBtn) soundBtn.addEventListener('click', () => {
      const on = video.muted;
      setSound(on);                      // inside the click, so the browser allows the sound
      if (on) {
        if (held) { held = false; label(); }
        if (!kind) load();
        update();
      }
    });
    if (playBtn) playBtn.addEventListener('click', () => {
      held = !held;
      label();
      if (!kind) load();
      update();
    });
    const ringBtn = film.querySelector('[data-film-ring]');
    if (ringBtn) ringBtn.addEventListener('click', () => {
      held = false;
      label();
      if (!kind) load();
      update();
    });
    label();
    if ('IntersectionObserver' in window) {
      const nearby = new IntersectionObserver((entries) => {
        if (!entries[entries.length - 1].isIntersecting) return;
        load();
        nearby.disconnect();
      }, { rootMargin: '600px 0px' });
      nearby.observe(film);
      // the latest entry counts (a quick flick can bring "in" and "out" together)
      new IntersectionObserver((entries) => { inView = entries[entries.length - 1].isIntersecting; update(); }, { threshold: 0.25 }).observe(film);
    } else {
      inView = true;
      load();
    }
    const swap = () => { if (kind) load(); };
    if (phone.addEventListener) phone.addEventListener('change', swap); else if (phone.addListener) phone.addListener(swap);
  });

  run('intro', () => {
    // The river drawing starts once the section is on screen, and its looping motion runs only while it can be seen.
    // Only inside the A/B/C viewer (an iframe whose page has a section under review) does it also wait until that page
    // is the one shown; everywhere else (the page itself, the preview, Shopify's theme editor) it never waits.
    const sec = document.querySelector('section[data-rv]');
    if (!sec) return;
    if (still || !('IntersectionObserver' in window)) {
      sec.classList.add('is-drawn', 'is-still');
      return;
    }
    const liveAfter = Number(sec.dataset.liveAfter) || 0;
    const inViewer = window.parent !== window && !!document.querySelector('[data-review]');
    let shown = !inViewer;
    let inView = false;
    let near = false;
    let started = false;
    const update = () => {
      sec.classList.toggle('is-paused', !(shown && inView));
      if (started || !shown || !near) return;
      started = true;
      sec.classList.add('is-drawn');
      if (liveAfter) setTimeout(() => sec.classList.add('is-live'), liveAfter);
    };
    new IntersectionObserver((entries) => {
      const en = entries[entries.length - 1];           // the latest entry counts (a quick flick brings two)
      inView = en.isIntersecting;
      near = near || en.intersectionRatio >= 0.12;
      update();
    }, { threshold: [0, 0.12] }).observe(sec);
    if (inViewer) {
      let heard = false;
      addEventListener('message', (e) => {
        const d = e.data || {};
        if (d.nnPreview === 'shown' || d.nnPreview === 'hidden') {
          heard = true;
          shown = d.nnPreview === 'shown';
          update();
        }
      });
      // Safety net: if the viewer never says (a lost message, an older viewer), draw anyway rather than stay empty.
      setTimeout(() => { if (!heard) { shown = true; update(); } }, 2500);
    }
  });

  run('engraving', () => {
    // Engraving preview on two straight-on pictures of one watch (rose gold Neris): its caseback and its strap's clasp.
    // One field writes on both. Each picture says where its words sit (--x, --y in the styles) and how much room they
    // have (data-fit-w/h as shares of the picture's width, data-lines); longer text wraps first, then gets smaller.
    // An idea can bring its own words and letters (data-eg-value; data-eg-set-style="script" for handwriting). The
    // "Logotipas" idea (data-eg-logo) shows a sample logo instead of words until something is typed. Every change
    // fires "eg:change" for the river light.
    const root = document.querySelector('[data-eg]');
    const input = root && root.querySelector('[data-eg-input]');
    if (!input) return;
    const surfaces = [...root.querySelectorAll('[data-eg-surface]')].map((el) => ({
      el, text: el.querySelector('[data-eg-text]'), hi: el.querySelector('[data-eg-hi]'),
      w: Number(el.dataset.fitW), h: Number(el.dataset.fitH), lines: Number(el.dataset.lines) || 2,
    })).filter((s) => s.text);
    const ideas = [...root.querySelectorAll('[data-eg-idea]')];
    const logoBtn = root.querySelector('[data-eg-logo]');
    const hint = input.placeholder;

    const setMode = (m) => {
      root.dataset.mode = m;
      if (logoBtn) logoBtn.setAttribute('aria-pressed', String(m === 'logo'));
      input.placeholder = m === 'logo' ? 'Arba įrašykite tekstą' : hint;
    };
    const setStyle = (st, then) => {          // handwriting waits for its font, so the words fit at once
      root.dataset.style = st;
      if (st === 'script' && document.fonts) document.fonts.load('400 40px Allura').then(then, then);
      else then();
    };
    const split = (words, n) => {             // n lines of similar length
      if (n <= 1 || words.length < 2) return [words.join(' ')];
      const goal = words.join(' ').length / n;
      const lines = [];
      let cur = [];
      words.forEach((w, i) => {
        if (cur.length && cur.join(' ').length + w.length / 2 > goal && lines.length < n - 1 && words.length - i >= n - 1 - lines.length) {
          lines.push(cur.join(' '));
          cur = [];
        }
        cur.push(w);
      });
      lines.push(cur.join(' '));
      return lines;
    };
    const show = (s, lines, f) => {
      const t = lines.join('\n');
      [s.text, s.hi].forEach((el) => {
        if (!el) return;
        el.textContent = t;
        el.style.setProperty('--fit', f);
      });
    };
    const fit = (s) => {
      const words = input.value.trim().split(/\s+/).filter(Boolean);
      const W = s.el.clientWidth;
      if (!W) return;
      if (!words.length) { show(s, [''], 1); return; }
      let best = null;
      for (let n = 1; n <= s.lines; n++) {
        const lines = split(words, n);
        if (n > 1 && lines.length < n) break;
        s.text.style.setProperty('--fit', 1);
        s.text.textContent = lines.join('\n');
        const f = Math.min(1, (W * s.w) / s.text.offsetWidth, (W * s.h) / s.text.offsetHeight);
        if (!best || f > best.f + 0.001) best = { lines, f };
        if (f >= 0.82) break;
      }
      show(s, best.lines, Math.max(0.34, best.f));
    };
    const fitAll = () => surfaces.forEach(fit);
    const markIdeas = () => {
      const t = input.value.trim();
      ideas.forEach((b) => {
        const v = (b.dataset.egValue || b.textContent).trim();
        b.setAttribute('aria-pressed', String(root.dataset.mode !== 'logo' && v === t && (b.dataset.egSetStyle || 'serif') === root.dataset.style));
      });
    };
    const changed = (how) => root.dispatchEvent(new CustomEvent('eg:change', { detail: { how } }));

    input.addEventListener('input', () => { setMode('text'); fitAll(); markIdeas(); changed('type'); });
    ideas.forEach((b) => b.addEventListener('click', () => {
      setMode('text');
      input.value = b.dataset.egValue || b.textContent;
      setStyle(b.dataset.egSetStyle || 'serif', () => { fitAll(); markIdeas(); changed('idea'); });
    }));
    if (logoBtn) logoBtn.addEventListener('click', () => {
      input.value = '';
      setMode('logo');
      markIdeas();
      changed('idea');
    });
    setMode('text');
    if (!root.dataset.style) root.dataset.style = 'serif';
    fitAll();
    markIdeas();
    let width = innerWidth;                              // phones fire resize while their toolbar slides: width only
    addEventListener('resize', () => { if (innerWidth !== width) { width = innerWidth; fitAll(); } });
    if (document.fonts) document.fonts.ready.then(fitAll);
    // the pictures load lazily: fit again once each has its size
    root.querySelectorAll('img').forEach((im) => { if (!im.complete) im.addEventListener('load', fitAll, { once: true }); });
  });

  run('words', () => {
    // The river of words over the confluence picture: real engravings flow along the two rivers and meet in the middle
    // of the water. The page draws them itself on the canvas, every letter at its exact (fractional) place and turned
    // smoothly with the line, so they glide; a browser laying out text on a path snaps each letter to whole pixels,
    // which makes moving letters twitch. Each picture has an SVG holding its lines and words in its own pixels (the wide
    // photo on computers, the 9:16 one on phones): the canvas reads the one the screen shows, and that SVG stays as the
    // still picture if anything here cannot run. Moves only while on screen; stands still for people who prefer less
    // motion.
    const sec = document.querySelector('.words');
    const canvas = sec && sec.querySelector('.words-canvas');
    const ctx = canvas && canvas.getContext && canvas.getContext('2d');
    const svgs = sec ? [...sec.querySelectorAll('.words-river')] : [];
    if (!ctx || !svgs.length) return;
    const views = new Map();
    const viewOf = (svg) => {                            // a picture's lines, read once
      if (views.has(svg)) return views.get(svg);
      const [mx, my] = (svg.dataset.meet || '0 0').split(' ').map(Number);
      const lines = [...svg.querySelectorAll('textPath[data-wr]')].map((tp) => {
        const path = svg.querySelector(tp.getAttribute('href'));
        const len = path.getTotalLength();
        const n = Math.ceil(len);
        const pts = new Float32Array((n + 2) * 2);       // a point for every unit along the line
        for (let i = 0; i <= n + 1; i++) {
          const p = path.getPointAtLength(Math.min(i, len));
          pts[2 * i] = p.x;
          pts[2 * i + 1] = p.y;
        }
        return { tp, len, n, pts, dir: Number(tp.dataset.dir) || 1, glyphs: [], round: 0, at: 0 };
      });
      const v = { svg, lines, mx, my, vw: svg.viewBox.baseVal.width, vh: svg.viewBox.baseVal.height,
        speed: Number(svg.dataset.speed) || 22, size: 33, laid: false };
      views.set(svg, v);
      return v;
    };
    let view = null;
    const point = (l, u) => {                            // the point at distance u along line l
      const f = Math.max(0, Math.min(l.n, u));
      const i = Math.floor(f);
      const t = f - i;
      const p = l.pts;
      return [p[2 * i] + (p[2 * i + 2] - p[2 * i]) * t, p[2 * i + 1] + (p[2 * i + 3] - p[2 * i + 1]) * t];
    };
    const layout = (v) => {     // each letter's middle along its line (kerning kept) and the length of one round
      v.size = parseFloat(getComputedStyle(v.svg.querySelector('.wr')).fontSize) || 33;
      const fonts = { plain: `italic 400 ${v.size}px "EB Garamond", Georgia, serif`, hand: `400 ${v.size * 1.32}px Allura, "EB Garamond", serif` };
      v.lines.forEach((l) => {
        let x = 0;
        l.glyphs = [];
        [...l.tp.children].forEach((sp) => {
          const font = fonts[sp.classList.contains('wr-hand') ? 'hand' : 'plain'];
          const alpha = sp.classList.contains('wr-dot') ? 0.45 : 1;
          const text = sp.textContent;
          ctx.font = font;
          let before = 0;
          for (let i = 0; i < text.length; i++) {
            const upto = ctx.measureText(text.slice(0, i + 1)).width;
            if (text[i] !== ' ') l.glyphs.push({ ch: text[i], mid: x + (before + upto) / 2, w: upto - before, font, alpha });
            before = upto;
          }
          x += before;
        });
        const round = x / 2;                             // the words are written twice
        if (round && !l.round) l.at = round * (l.dir > 0 ? 0.17 : 0.46);
        l.round = round;
        if (round) l.at %= round;
      });
      v.laid = true;
    };
    let W = 0;
    let H = 0;
    let S = 1;
    let OX = 0;
    let OY = 0;
    const fit = () => {          // the picture the screen shows, and its "cover" fit in canvas pixels
      const shown = svgs.find((s) => getComputedStyle(s).display !== 'none') || svgs[0];
      view = viewOf(shown);
      if (!view.laid) layout(view);
      const r = canvas.getBoundingClientRect();
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      W = Math.max(1, Math.round(r.width * dpr));
      H = Math.max(1, Math.round(r.height * dpr));
      if (canvas.width !== W) canvas.width = W;
      if (canvas.height !== H) canvas.height = H;
      S = Math.max(r.width / view.vw, r.height / view.vh) * dpr;
      OX = (W - view.vw * S) / 2;
      OY = (H - view.vh * S) / 2;
    };
    const fade = (x, y) => {     // the words fade where the lines meet
      const t = Math.max(0, Math.min(1, (Math.hypot(x - view.mx, y - view.my) - view.size) / (view.size * 3.6)));
      return t * t * (3 - 2 * t);
    };
    // All the letters set once on one sheet (at twice the canvas' scale), then each frame only places and turns
    // cut-outs of it: sending three hundred turned letters as type to the graphics chip every frame took a slower
    // phone 15 ms a frame (2026-10-20, the owner's tablet). Until the sheet is ready, and wherever a browser cannot
    // make one, the letters are set as type as before. A new sheet comes with a new scale.
    const Q = 2;
    let sheet = null;
    let sheetS = 0;
    let sheetBusy = false;
    const makeSheet = () => {
      if (sheetBusy || !window.createImageBitmap || !view) return;
      sheetBusy = true;
      const s = S;
      const keys = new Map();
      view.lines.forEach((l) => l.glyphs.forEach((g) => { const k = `${g.font}\u0000${g.ch}`; if (!keys.has(k)) keys.set(k, g); }));
      const m = document.createElement('canvas').getContext('2d');
      const pad = 3;
      const cells = [];
      let x = 0;
      let y = 0;
      let row = 0;
      const maxW = 2048;
      keys.forEach((g, k) => {
        m.font = g.font;
        const t = m.measureText(g.ch);
        const left = Math.ceil((t.actualBoundingBoxLeft || 0) * s * Q) + pad;
        const w = left + Math.ceil((t.actualBoundingBoxRight || t.width) * s * Q) + pad;
        const asc = Math.ceil((t.actualBoundingBoxAscent || g.w) * s * Q) + pad;
        const h = asc + Math.ceil((t.actualBoundingBoxDescent || 0) * s * Q) + pad;
        if (x + w > maxW) { x = 0; y += row; row = 0; }
        cells.push({ k, g, x, y, w, h, left, asc });
        x += w;
        row = Math.max(row, h);
      });
      const c = document.createElement('canvas');
      c.width = maxW;
      c.height = Math.max(1, y + row);
      const cx = c.getContext('2d');
      cx.fillStyle = '#fff';
      const map = new Map();
      cells.forEach((q) => {
        cx.font = q.g.font;
        cx.setTransform(s * Q, 0, 0, s * Q, q.x + q.left, q.y + q.asc);
        cx.fillText(q.g.ch, 0, 0);
        map.set(q.k, q);
      });
      createImageBitmap(c).then((bmp) => {
        sheetBusy = false;
        if (s !== S) { makeSheet(); return; }          // the scale changed meanwhile
        sheet = { bmp, map };
        sheetS = s;
      }, () => { sheetBusy = false; });
    };
    const draw = () => {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#fff';
      if (sheetS !== S) { sheet = null; makeSheet(); }
      const sh = sheet;
      if (sh) ctx.imageSmoothingQuality = 'high';
      let font = '';
      view.lines.forEach((l) => {
        if (!l.round) return;
        const base = l.at - l.round;
        l.glyphs.forEach((g) => {
          const u = base + g.mid;
          if (u < 0 || u > l.len) return;
          const [x, y] = point(l, u);
          const a = fade(x, y) * g.alpha * 0.9;
          if (a < 0.01) return;
          const [x0, y0] = point(l, u - 8);
          const [x1, y1] = point(l, u + 8);
          const turn = Math.atan2(y1 - y0, x1 - x0);
          const q = sh && sh.map.get(`${g.font}\u0000${g.ch}`);
          ctx.globalAlpha = a;
          if (q) {
            const c = Math.cos(turn) / Q;
            const s = Math.sin(turn) / Q;
            ctx.setTransform(c, s, -s, c, OX + x * S, OY + y * S);
            ctx.drawImage(sh.bmp, q.x, q.y, q.w, q.h, -(g.w / 2) * S * Q - q.left, -q.asc, q.w, q.h);
            return;
          }
          const c = Math.cos(turn) * S;
          const s = Math.sin(turn) * S;
          if (g.font !== font) { ctx.font = g.font; font = g.font; }
          ctx.setTransform(c, s, -s, c, OX + x * S, OY + y * S);
          ctx.fillText(g.ch, -g.w / 2, 0);
        });
      });
    };
    let raf = 0;
    let last = 0;
    let ready = false;
    // A phone that cannot keep up (its frames slower than 1/45 s on average) moves the words on every other frame:
    // at their pace they still glide, and the page keeps the rest of its frames (2026-10-20, the owner's tablet).
    let pace = 16.7;
    let prev = 0;
    let skip = false;
    const step = (now) => {
      // the words hold still while the page scrolls (core.js 'scrolling'): redrawing them every frame is what made a
      // slower phone's scroll stutter here
      if (window.nnScrolling) { last = 0; prev = 0; raf = requestAnimationFrame(step); return; }
      if (prev) pace = pace * 0.95 + Math.min(100, now - prev) * 0.05;
      prev = now;
      skip = pace > 22 && !skip;
      if (skip) { raf = requestAnimationFrame(step); return; }
      const dt = last ? Math.min(0.05, (now - last) / 1000) : 0;
      last = now;
      view.lines.forEach((l) => { if (l.round) l.at = (((l.at + view.speed * l.dir * dt) % l.round) + l.round) % l.round; });
      draw();
      raf = requestAnimationFrame(step);
    };
    const begin = () => {
      if (ready) return;
      fit();
      draw();
      ready = true;
      sec.classList.add('is-drawing');
      if (still || !('IntersectionObserver' in window)) return;
      new IntersectionObserver((entries) => {             // the latest entry counts (a quick flick brings two)
        cancelAnimationFrame(raf);
        last = 0;
        if (entries[entries.length - 1].isIntersecting) raf = requestAnimationFrame(step);
      }).observe(sec);
    };
    const redraw = () => { if (ready) { fit(); draw(); } };
    if ('ResizeObserver' in window) new ResizeObserver(redraw).observe(canvas);
    else addEventListener('resize', redraw);
    const letters = 'Aaąčęėįšųūž';                       // the Lithuanian letters live in a second font file
    const fontsReady = document.fonts
      ? Promise.all([document.fonts.load('italic 400 33px "EB Garamond"', letters), document.fonts.load('400 44px Allura', letters)])
      : Promise.resolve();
    fontsReady.then(() => run('words: start', begin), () => run('words: start', begin));
  });

  run('engraving rivers', () => {
    // The two rivers under the pictures draw in when they come into view (or as soon as the words change), and each
    // new text, after a short pause in typing, sends a light from the field up both of them.
    const root = document.querySelector('.eg2a');
    const rivers = root && root.querySelector('[data-eg2a-rivers]');
    if (!rivers) return;
    const draw = () => rivers.classList.add('is-drawn');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        draw();
        io.disconnect();
      }, { threshold: 0.6 });
      io.observe(rivers);
    } else draw();
    let t;
    root.addEventListener('eg:change', (e) => {
      draw();
      clearTimeout(t);
      t = setTimeout(() => {
        root.classList.remove('is-flow');
        void root.offsetWidth;                 // restart the animation
        root.classList.add('is-flow');
      }, e.detail.how === 'type' ? 320 : 0);
    });
  });
})();
